import React, { useState, useEffect } from 'react'
import { DataTable, Button, Pagination } from '@arnsbogroup/react-voicearchive'

const exportToCsv = (entries, filename) => {
  if (!entries?.length) return
  const headers = Object.keys(entries[0])
  const csv = [
    headers.join(','),
    ...entries.map(row =>
      headers.map(h => `"${String(row[h] ?? '').replace(/"/g, '""')}"`).join(',')
    ),
  ].join('\n')
  const link = Object.assign(document.createElement('a'), {
    href: URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' })),
    download: filename,
  })
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const DataTableOutput = ({ descriptor, data, pageSize = 50 }) => {
  const [page, setPage] = useState(1)

  useEffect(() => {
    setPage(1)
  }, [data])

  if (!data?.length) {
    return <div className="text-gray-500 text-sm py-2">No data found</div>
  }

  const keys    = Object.keys(data[0])
  const head    = keys.reduce((acc, key) => ({ ...acc, [key]: { label: key } }), {})
  const body    = keys.reduce((acc, key) => ({ ...acc, [key]: row => <span>{row[key]}</span> }), {})
  const paged   = data.slice((page - 1) * pageSize, page * pageSize)

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        {descriptor.label && <h3 className="font-medium text-gray-700">{descriptor.label}</h3>}
        <Button variant="outline" size="sm" onClick={() => exportToCsv(data, descriptor.filename)}>
          Export CSV
        </Button>
      </div>
      <div className="overflow-x-auto">
        <DataTable head={head} body={body} entries={paged} noDataMessage="No data found" />
      </div>
      {data.length > pageSize && (
        <Pagination
          key={page}
          page={page}
          pageSize={pageSize}
          totalItems={data.length}
          onChange={setPage}
        />
      )}
    </div>
  )
}

export default DataTableOutput
